<template>
  <HeaderTitle :back-target-func="backToFeed">
    <template #top>{{ t("dashboard.favorites.tile.title") }}</template>
    <template #bottom>{{ t("dashboard.favorites.tile.subtitle") }}</template>
  </HeaderTitle>
  <div
    v-if="favorites.length > 0"
    class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4"
  >
    <div v-for="article in favorites" :key="article.id" class="h-full">
      <div class="p-4 flex flex-col h-full pb-8">
        <ArticleCard
          :article-id="article.id"
          :title="article.title"
          :image-url="article.thumbnailURL"
          :image-alt-text="article.thumbnailURLDescription"
          :source-type="article.type"
          :teaser="article.teaserText"
          :is-favorite="article.isFavorite"
          origin="favorites"
          @remove-favorite="removeFavorite(article.id)"
        />
      </div>
    </div>
  </div>
  <div v-else class="flex flex-col items-center justify-center text-large">
    {{ t("favorite.articles.screen.no.favorites") }}
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { onMounted, ref } from "vue";
import { useUserStore } from "../../../store/v2/user";
import { fetchFavoriteArticles } from "../../../api/v2/feed";
import { FavoriteDto } from "../../../dto/favorite.dto";
import ArticleCard from "../../../components/v2/article/ArticleCard.vue";
import HeaderTitle from "../../../components/v2/layout/header/HeaderTitle.vue";
import { useRouter } from "vue-router";

const { t } = useI18n();
const userStore = useUserStore();
const favorites = ref<FavoriteDto[]>([]);
const router = useRouter();

onMounted(async () => {
  const res = await fetchFavoriteArticles(userStore.getExternalUserId);
  if (res.data) {
    favorites.value = res.data;
  }
});

function removeFavorite(id: string) {
  favorites.value = favorites.value.filter((article) => article.id !== id);
}

function backToFeed() {
  router.push({ name: "feed", state: { fromFavorite: true } });
}
</script>
